module.exports = __webpack_public_path__ + "static/media/image_slider_home_04.cf682d81.jpg";